const envVariables = process.env

const Config: any = {}

Object.keys(envVariables).forEach(variable => {
   if (variable.includes('NX')) {
      const envKey = variable.replace('NX_', '')
      Config[envKey] = envVariables[variable]
   }
})

export { Config }

export const DEV_ENVIRONMENT_NAME_CONSTANTS: Array<string> = ['DEV']

export const GAMMA_ENVIRONMENT_NAME_CONSTANTS: Array<string> = ['GAMMA']

export const BN_PROD_ENV_NAME = 'BN_PROD'

export const BN_UAT_ENV_NAME = 'BN_UAT'

export const GAMMA_ENV_NAME = 'GAMMA'

export const BN_GAMMA_ENV_NAME = 'BN_GAMMA'

export const PROD_ENVIRONMENT_NAME_CONSTANTS: Array<string> = [
   BN_PROD_ENV_NAME,
   'BN_GAMMA',
   BN_UAT_ENV_NAME,
   'PRODUCTION',
   'STAGING'
]

export const isDevelopmentEnvironment = DEV_ENVIRONMENT_NAME_CONSTANTS.includes(
   Config.ENV_NAME
)

export const SUPPORTED_ENVIRONMENTS_WITHOUT_BROWSER_COMPATIBILITY_CHECK = [
   ...DEV_ENVIRONMENT_NAME_CONSTANTS,
   ...GAMMA_ENVIRONMENT_NAME_CONSTANTS
]

export const shouldSkipBrowserCompatibilityCheck = SUPPORTED_ENVIRONMENTS_WITHOUT_BROWSER_COMPATIBILITY_CHECK.includes(
   Config.ENV_NAME
)

export const isProductionEnvironment = PROD_ENVIRONMENT_NAME_CONSTANTS.includes(
   Config.ENV_NAME
)

export const APP_BASE_URL = Config.FRONTEND_BASE_URL

export const DEV_SERVER_HOST_NAME = 'localhost'
